import {
    PROFILE
} from "@/api/users/users";
import { ROLE_HSE, ROLE_ADMIN_PJO } from "@/constants/mitraRole";


const state = {
    profiles: {},
    userProfile: {}

};

const mutations = {
    setProfile: (states, payload) => {
        states.profiles = payload;
    },
    commitProfile: (states, payload) => {
        states.userProfile = payload;
        
    },
};

const actions = {
    getProfile: async ({
        commit
    }) => {
        try {
            const resp = await PROFILE()
            const datas = resp.data.data
            
            // Initialize roles_uenroll as array if not exists
            if (!Array.isArray(datas.roles_uenroll)) {
                datas.roles_uenroll = [];
            }
            
            console.log('👤 User Profile:', {
                email: datas.email,
                roles_uenroll: datas.roles_uenroll
            });

            commit("setProfile", datas);
        } catch (err) {
            let resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("setProfile", {
                    setProfile: {},
                });
            }
        }
    },

};

const getters = {
    profileData: (states) => states.profiles,
    profiles: (states) => states.userProfile

};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};